import { FtpService } from "../domainObjects/dataConnector";

export class GetDefaultIngestNodePathRequest {
    dataSourceType: number;
    organizationId: number;
    isUseFtp:boolean;
    ftpService: FtpService;
    refineryConfigGuid: string;
    dataConnectorType: number;

    constructor(dataSourceType: number, organizationId: number,isUseFtp:boolean,ftpService: FtpService, refineryConfigGuid: string = '', dataConnectorType: number = 0) {
      this.dataSourceType = dataSourceType;
      this.organizationId = organizationId;
      this.isUseFtp = isUseFtp;
      this.ftpService = ftpService;
      this.refineryConfigGuid = refineryConfigGuid;
      this.dataConnectorType = dataConnectorType;
    }
}

